<template>
  <div :class="$style.stats">
    <div v-for="stat in values" :key="stat.name" :class="$style.stat">
      <div :class="$style.statName">
        {{ stat.name }}
      </div>
      <div :class="$style.statValue">
        {{ stat.value }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    values: { type: Array, required: true },
  },
});
</script>

<style lang="scss" module>
.stats {
  display: flex;
  flex-wrap: wrap;
  margin: -10px -45px 0 -45px;

  @media screen and (max-width: 620px) {
     margin: -10px -30px 0 -30px;
  }
}

.stat {
  min-width: 170px;
  padding: 0 45px;
  margin-top: 10px;
}

.statName {
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.02em;

  color: rgba(63, 71, 87, 0.45);
  margin-bottom: 12px;
}
.statValue {
  font-size: 24px;
  color: #2f3543;
}
</style>
